import Poptip from './slotPopTip.js'
import DPoptip from './d-poptip.js'

Poptip.DPoptip = DPoptip

export default Poptip



// WEBPACK FOOTER //
// ./src/components/poptip/index.js